import { Component, OnInit } from "@angular/core";
import { VernostServiceService } from "../services/vernost-service.service";

@Component({
  selector: "app-forgotpassword",
  templateUrl: "./forgotpassword.component.html",
  styleUrls: ["./forgotpassword.component.css"]
})
export class ForgotpasswordComponent implements OnInit {
  screen_details: any = {};
  emailPattern;
  mobilePattern;
  loader: boolean = false;
  //emailPattern = "^w+([.-]?w+)*@w+([.-]?w+)*(.w{2,3})+$";
  parent_table = "mst_user";
  // mobilePattern = "^(+d{1,3}[- ]?)?d{10}$";
  // parent_table_ID = "FARE_PRODUCT_ID";
  isMobileValid: boolean = true;
  isEmailValid: boolean = true;
  constructor(private service: VernostServiceService) { }

  ngOnInit() {
    this.isEmailValid = true;
    this.isMobileValid = true;
    this.screen_details = {
      email: "",
      mobileno: ""
    };
  }
  clearErroMassages(id) {
    document.getElementById("error").innerHTML = "";

    if (id == 1) {
      document.getElementById("emailErr").innerHTML = "";
      document.getElementById("subMitBtn").style.cursor = "";
      document.getElementById("subMitBtn").style.background = "";
      this.isEmailValid = true;
    }
    if (id == 2) {
      document.getElementById("mobileNoErr").innerHTML = "";
      document.getElementById("subMitBtn").style.cursor = "";
      document.getElementById("subMitBtn").style.background = "";
      this.isMobileValid = true;
    }
  }
  checkMobileNo(data) {
    var regx = /^(\+\d{1,3}[- ]?)?\d{10}$/;

    if (data != "" && regx.test(data) == false) {
      console.log("OUT");
      document.getElementById("mobileNoErr").innerHTML =
        "Invaild Mobile Number";
      document.getElementById("mobileNoErr").style.color = "red";
      this.isMobileValid = false;
      document.getElementById("subMitBtn").style.cursor = "not-allowed";
      document.getElementById("subMitBtn").style.background = "#4e8efab8";
    } else {
      document.getElementById("mobileNoErr").innerHTML = "";
      this.isMobileValid = true;
      document.getElementById("subMitBtn").style.cursor = "";
      document.getElementById("subMitBtn").style.background = "";
    }
  }
  checkEmailNames(data) {
    var regx = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;

    if (data != "" && regx.test(data) == false) {
      console.log("OUT");
      document.getElementById("emailErr").innerHTML = "Invaild Username";
      document.getElementById("emailErr").style.color = "red";
      this.isEmailValid = false;
      document.getElementById("subMitBtn").style.cursor = "not-allowed";
      document.getElementById("subMitBtn").style.background = "#4e8efab8";

      // this.userEmail = true;
    } else {
      document.getElementById("emailErr").innerHTML = "";
      // this.userEmail = false;
      this.isEmailValid = true;
      document.getElementById("subMitBtn").style.cursor = "";
      document.getElementById("subMitBtn").style.background = "";
    }
  }
  submitdata() {
    this.loader = true;
    var email = this.screen_details.email;
    var mobileno = this.screen_details.mobileno;
    console.log(email);
    console.log(mobileno);
    if (email == "") {
      document.getElementById("emailErr").innerHTML = "Please Enter Email";
      document.getElementById("emailErr").style.color = "red";
      this.loader = false;
    } else {
      document.getElementById("emailErr").innerHTML = "";
    }
    if (mobileno == "") {
      document.getElementById("mobileNoErr").innerHTML =
        "Please Enter Mobile Number";
      document.getElementById("mobileNoErr").style.color = "red";
      this.loader = false;
    } else {
      document.getElementById("mobileNoErr").innerHTML = "";
    }

    if (email != "" && mobileno != "") {
      var data = {
        email: email,
        mobileno: mobileno,
        parent_table: this.parent_table
      };
      this.service.forgotpassword(data).subscribe(response => {
        this.loader = false;
       // console.log("bwqhdkjkdjkwjwjdwq===================", response);
        // alert(JSON.stringify(response[0].message));
        document.getElementById("error").innerHTML = response[0].message;
      });
    }
  }
}
